module.exports = __webpack_public_path__ + "static/img/03_11.3949783.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/alipay/03_11.png
// module id = hqy2
// module chunks = 1